export default __webpack_public_path__ + "0ee762e71d13eee31924788e7616e2d8.png";